import React, { useEffect, useState } from "react";
import api from "../../api";

export default function ProgressCard() {
  const [data, setData] = useState(null);
  const [newTarget, setNewTarget] = useState("");
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchProgress();
  }, []);

  const fetchProgress = async () => {
    try {
      const res = await api.get("/admin/progress");
      setData(res.data);
    } catch (err) {
      console.error("Error fetching progress data", err);
    } finally {
      setLoading(false);
    }
  };

  const handleTargetUpdate = async () => {
    try {
      const res = await api.post("/admin/set-target", {
        target: parseInt(newTarget),
      });
      if (res.data.success) {
        fetchProgress();
        setMessage("Target updated successfully ✅");
        setNewTarget("");
      } else {
        setMessage("Update failed. Try again ❌");
      }
    } catch (err) {
      console.error("Failed to update target", err);
      setMessage("Error updating target ❌");
    }
  };

  if (loading) return <p className="admin-progress-loading">Loading...</p>;

  return (
    <div className="admin-progress-card">
      <h3 className="admin-progress-title">Attendance Progress</h3>
      <p className="admin-progress-value">
        {data?.progress || 0}% Target Achieved
      </p>
      <div className="progress-bar">
        <div className="progress-fill" style={{ width: `${data.progress}%` }} />
      </div>

      <p className="admin-progress-details">
        🎯 Target: <strong>{data?.target}</strong> | ✅ Attended:{" "}
        <strong>{data?.attended}</strong> | 🧑‍🎓 Total:{" "}
        <strong>{data?.total}</strong>
      </p>

      <div className="admin-progress-input-wrap">
        <input
          type="number"
          placeholder="Update Target"
          value={newTarget}
          onChange={(e) => setNewTarget(e.target.value)}
          className="admin-progress-input"
        />
        <button onClick={handleTargetUpdate} className="admin-progress-button">
          Update Target
        </button>
      </div>

      {message && <p className="admin-progress-message">{message}</p>}
    </div>
  );
}
